const appConfig = {
  // apiGateways: {
    BASE_URL: `${process.env.REACT_APP_BACKEND_URL_HTTP}`,
    OPERATOR_BASE_URL: `${process.env.REACT_APP_OPERATOR_BACKEND_URL_HTTP}`,
    GAME_BASE_URL: `${process.env.REACT_APP_USER_FRONTEND_URL_HTTP}`
  // },
  // SOCKET_URL: `${process.env.REACT_APP_BACKEND_URL_WS}`,
  // REACT_APP_ENV: process.env.REACT_APP_ENV || 'development',
  // SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN
}

export default appConfig
